let $ = require('jquery');
let _ = require('lodash');
let css = require('./header.css');
let {cut} = require('../../../helpers/utils');
const Price = require('./price');
const MakeOrderButton = require('./make-order-button');

const IS_STICKED = css.isSticked;
const WRAPPER = cut(css.wrapper);

class OrderHeader {
    constructor() {
        this.template = require('./template.hbs');
    }

    bind() {
        this.initScroller();
    }

    unbind() {
        $(window).unbind('scroll', this._scrollHandler);
    }

    render() {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, {css}));
    }

    initScroller() {
        let header = $(this.$context.getComponentById('header').$context.element);
        this.headerHeight = header.height();
        this.wrapperElement = $(this.$context.element).find(WRAPPER);
        this._scrollHandler = _.bind(this.scrollHandler, this);

        $(window).scroll(this._scrollHandler);
        this.scrollHandler();
    }

    scrollHandler() {
        let topView = $(window).scrollTop();
        let viewLessHeader = topView >= this.headerHeight;

        this.wrapperElement.toggleClass(IS_STICKED, viewLessHeader);
    }
}

module.exports = {
    constructor: OrderHeader,
    children: [
        {
            name: 'price',
            component: Price,
            watcher: {
                rowPrice: ['order', 'price', 'data', 'total', 'rowPrice'],
                totalPrice: ['order', 'price', 'data', 'total', 'totalPrice'],
                noDiscountTotalPrice: ['order', 'price', 'data', 'total', 'totalPriceWithoutDiscount'],
                discountPercentage: ['order', 'price', 'data', 'total', 'discountPercentage'],
                rowAmount: ['order', 'price', 'data', 'total', 'rowAmount'],
                firmsPluralized: ['order', 'price', 'computed', 'firmsPluralized'],
                isLoading: ['order', 'price', 'isLoading'],
                isError: ['order', 'price', 'isError'],
                tooltipIsShow: ['order', 'price', 'tooltipIsShow']
            }
        },
        {
            name: 'make-order-button',
            component: MakeOrderButton,
            watcher: {
                totalPrice: ['order', 'price', 'data', 'total', 'totalPrice'],
                isZero: ['order', 'price', 'isZero']
            },
            props: {
                isUp: true
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/order/header/index.js